import { render, staticRenderFns } from "./DashBoardProductChart.vue?vue&type=template&id=53f38c46&scoped=true"
import script from "./DashBoardProductChart.vue?vue&type=script&lang=js"
export * from "./DashBoardProductChart.vue?vue&type=script&lang=js"
import style0 from "./DashBoardProductChart.vue?vue&type=style&index=0&id=53f38c46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f38c46",
  null
  
)

export default component.exports